import React from 'react';
import { StarIcon } from 'lucide-react';
interface GoogleReviewsBadgeProps {
  variant?: 'light' | 'dark';
  size?: 'sm' | 'md';
}
export function GoogleReviewsBadge({
  variant = 'light',
  size = 'md'
}: GoogleReviewsBadgeProps) {
  const isLight = variant === 'light';
  const isSm = size === 'sm';
  return <a href="https://www.google.com/search?q=Smiths+and+Jengs+Cleaning+Service+Reviews" target="_blank" rel="noopener noreferrer" className={`inline-flex items-center group transition-opacity hover:opacity-90 ${isSm ? 'gap-3' : 'gap-4'}`} data-id="element-125">
      {/* Google "G" logo */}
      <svg viewBox="0 0 24 24" className={isSm ? 'w-8 h-8 shrink-0' : 'w-10 h-10 shrink-0'} data-id="element-126">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4" data-id="element-127" />
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-128" />
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-129" />
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-130" />
      </svg>

      {/* Stars */}
      <div className="flex flex-col" data-id="element-131">
        <div className={`flex items-center ${isSm ? 'gap-0.5' : 'gap-1'}`} data-id="element-132">
          {[...Array(5)].map((_, i) => <StarIcon key={i} size={isSm ? 18 : 25} className="text-[#FBBC05] fill-[#FBBC05]" data-id="element-133" />)}
        </div>
        <span className={`font-medium ${isSm ? 'text-[17px]' : 'text-[19px]'} ${isLight ? 'text-white/70' : 'text-gray-500'}`} data-id="element-134">
          5.0 · 21+ Reviews
        </span>
      </div>
    </a>;
}